module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst fieldConfig = model.config || {}\nconst fieldsConfig = fieldConfig.fields || {}\nconst disabled = ((formMapping || {}).fieldConfig || {}).disabled || fieldConfig.disabled;\nconst isFilterField = ((formMapping || {}).fieldConfig || {}).isFilterField;\nconst fieldClasses = [];\nif(config.bootstrapVersion){\nfieldClasses.push('form-control')\n}\nif(typeof(additionalCSSClass) === 'undefined'){\nfieldClasses.push(fieldClasses)\n}\nif(isFilterField){\n%><%- include('./text', { formMapping: formMapping, model: model }); %><%\n}\nelse {\n%><div><%\n%><textarea class=\"<%- fieldClasses.join(' ') %>\" data-field-type=\"textarea\" data-field-code=\"<%- model.fieldCode %>\"<%- (disabled ? 'disabled=\"disabled\"' : ''); %> placeholder=\"<%= model.placeholder || '' %>\"><%= model.dataTEXT %></textarea><%\n%><div class=\"controls\"><%\nif(fieldsConfig.copyToClipboard){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'copyToClipboard', context: 'text', symbolOnly: true } }); %><%\n}\n%></div><%\n%></div><%\n}\n%>"
  , __filename = "..\\frontend-controller\\baseComponents\\form\\fields\\textarea.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const fieldConfig = model.config || {}
const fieldsConfig = fieldConfig.fields || {}
const disabled = ((formMapping || {}).fieldConfig || {}).disabled || fieldConfig.disabled;
const isFilterField = ((formMapping || {}).fieldConfig || {}).isFilterField;
const fieldClasses = [];
if(config.bootstrapVersion){
fieldClasses.push('form-control')
}
if(typeof(additionalCSSClass) === 'undefined'){
fieldClasses.push(fieldClasses)
}
if(isFilterField){

    ; __line = 14
    ; __append( include('./text', { formMapping: formMapping, model: model }) )
    ; 
}
else {

    ; __line = 17
    ; __append("<div>")
    ; 

    ; __line = 18
    ; __append("<textarea class=\"")
    ; __append( fieldClasses.join(' ') )
    ; __append("\" data-field-type=\"textarea\" data-field-code=\"")
    ; __append( model.fieldCode )
    ; __append("\"")
    ; __append( (disabled ? 'disabled="disabled"' : '') )
    ; __append(" placeholder=\"")
    ; __append(escapeFn( model.placeholder || '' ))
    ; __append("\">")
    ; __append(escapeFn( model.dataTEXT ))
    ; __append("</textarea>")
    ; 

    ; __line = 19
    ; __append("<div class=\"controls\">")
    ; 
if(fieldsConfig.copyToClipboard){

    ; __line = 21
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'copyToClipboard', context: 'text', symbolOnly: true } }) )
    ; 
}

    ; __line = 23
    ; __append("</div>")
    ; 

    ; __line = 24
    ; __append("</div>")
    ; 
}

    ; __line = 26
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\form\fields\textarea.ejs

}